
import React, { useState, useRef } from "react";
import "../../styles.css";
import SingleCalendar from "../SingleCalendar";
import { BCMSDate } from "bcms-react"; 

export default function DateSelectView(props) {
  const ref = useRef();
  const { setDate, onChange } = props;
  const [isActive, setActive] = useState(props.active ?? false);  // Stores if view is rendered
  // Controllers accessible from custom hooK;
  let showTop = false;
  let enablePast =  props.enablePast ;
  let enableFuture = props.enableFuture;
  let disableDay = props.disableDay; 
  if(ref.current){  
    showTop = document.getElementById("root").getBoundingClientRect().bottom < ref.current.getBoundingClientRect().bottom+461    
  }
  const controllers = {
    "open": () =>   setActive(true),       // Opens view
    "close": () => setActive(false),      // closes view 
    "set": (value) => onChange(value),   // Sets value of container
    "get": () =>setDate,       // Gets value of container
    "toggle": () => {
      
      setActive(!isActive)
    
    
    }  // Toggle view
  }
  const use = props.use instanceof Function
    ? props.use
    : (controllers, children) => React.cloneElement(children, { controllers });
   
    
  return (
    <div className="date-select" ref={ref}>
      {/*The view of the date select when closed*/}
      {use(controllers, props.children)}
      {/*Show Single Date Select if screen is bigger than mobile threshold active*/}
      {isActive && <div className={"date-select-calendar"+ (showTop ?" show-top":"")} ><SingleCalendar controllers={controllers} {...props} setDate={setDate} onChange={onChange} inputDate={props.inputDate}  enablePast={enablePast} enableFuture={enableFuture} disableDay={disableDay}/></div>}
       {/*Transparent overlay to dismiss date select if clicked outside*/}
      {isActive && <div className="date-select-overlay" onClick={controllers.close}></div>}
    </div>
  );
}

